import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PropaneIcon(props: IconProps) {
    return <Icon {...props} iconKey={"propane"}/>
}
